import React from 'react'
import {
  BrowserRouter as Router
} from 'react-router-dom'
import CustomRoutes from './routes'

const Routes = () => (
  <Router>
    <CustomRoutes />
  </Router>
)

export default Routes
